<template>
    <legacy-group-report-template  v-model:current-report-template-id="currentReportTemplateId"
                            v-model:for-group="forGroup"
                            v-model:interval="$data._interval"
                            v-model:ran-report="$data._reportSuccessfullySent"
                            v-model:reload-data="$data._reloadTable"
                            v-model:running-errors="$data._errorSending"
                            v-model:running-report="$data._runningReport"
                            v-model:settings="$data._settings"
                            :can-edit="permissions.can('manage_excursion_report')"
                            :default-settings="defaultSettings"
                            :prepare-settings-function="$data._prepareSettingsFunction"
                            report-name="excursion-report"
                            v-model:display-section="displaySection"
                            @useStandardReporting="setUseStandardReporting"
                            @reset-settings="resetSelections"
    >
        <template   #create-settings>
            <!-- Add Excursion Report Settings -->
            <legacy-excursion-report-settings
                v-model:interval="$data._interval"
                v-model:settings="$data._settings"
                :is-savable="true"
                :timezone="timezone"
            ></legacy-excursion-report-settings>
        </template>

        <template   #edit-settings>
            <!-- Add Excursion Report Settings -->
            <legacy-excursion-report-settings
                v-model:interval="$data._interval"
                v-model:settings="$data._settings"
                :is-savable="displaySection === 'show-template' || useStandardReporting"
                :timezone="timezone"
            ></legacy-excursion-report-settings>
        </template>

        <template   #run-options="props">
            <legacy-meter-interval-selection   v-model:end-of-interval="endOfInterval"
                                        v-model:interval="$data._interval"
                                        v-model:selected-meters="$data._selectedMeters"
                                        v-model:semi-month-half="$data._semiMonthHalf"
                                        :meters="metersByGroup[props.groupId]"
                                        :max-date="maxDate"
                                        :min-date="minDate"
                                        :timezone="timezone"
                                        @run-report="runReport(currentReportTemplateId)"
            ></legacy-meter-interval-selection>
        </template>
    </legacy-group-report-template>
</template>

<script>
import axios from "axios"
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import {Intervals} from "@/components/GroupReports/Intervals";
import ReportHomeModal from "@/components/GroupReports/Legacy/LegacyReportHomeModal.vue";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";
import BaseReport from "@/components/Reports/BaseReport";
import MeterIntervalSelection from "@/components/GroupReports/Legacy/LegacyMeterIntervalSelection.vue";
import DetailedAlarmReportSettings from "@/components/GroupReports/Legacy/LegacyDetailedAlarmReportSettings.vue";
import AjaxTable from "@/components/elements/AjaxTable";
import Select2 from "@/components/elements/select2";
import SlideOverPanel from "@/components/elements/SlideOverPanel";
import ButtonRedSecondary from "@/components/elements/buttons/ButtonRedSecondary";
import ButtonGreenPrimary from "@/components/elements/buttons/ButtonGreenPrimary";
import GroupReportTemplate from "@/components/GroupReports/Legacy/LegacyGroupReportTemplate.vue";
import ExcursionReportSettings from "@/components/GroupReports/Legacy/LegacyExcursionReportSettings.vue";

export default {
    name: "GroupExcursionReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
        ExcursionReportSettings,
        GroupReportTemplate,
        ButtonGreenPrimary,
        ButtonRedSecondary,
        SlideOverPanel,
        AjaxTable,
        DetailedAlarmReportSettings, MeterIntervalSelection, BaseReport, ReportHomeModal, ButtonBlueSecondary, Select2,
        Menu, MenuButton, MenuItem, MenuItems,
    },
    props: {
        receiveWeekday: {
            type: Number,
            default: 1,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        minDate: {
            type: [Date, String],
        },
        maxDate: {
            type: [Date, String],
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
        metersByGroup: {
            type: Object,
            default() {
                return {}
            }
        },
        timezone: {
            type: String,
        },
    },
    data() {
        return {
            displaySection: null,

            // Manual Run Stuff
            _interval: this.interval,
            endOfInterval: new Date(),
            _semiMonthHalf: 'first',
            _selectedMeters: [],
            _templateName: '',
            _groupId: null,
            _prepareSettingsFunction: null,

            _data: [],
            _settings: this.defaultSettings,

            _reloadTable: false,
            _runningReport: false,
            _reportSuccessfullySent: false,
            _errorSending: [],

            currentReportTemplateId: null,
            forGroup: false,
            useStandardReporting: false,
        }
    },
    created() {
        this.$data._prepareSettingsFunction = (settings) => {
            // If the date is null, set it to 07:00 and 19:00 respectively.
            if (settings['logTime1'] === null) {
                settings['logTime1'] = '07:00'
            }
            if (settings['logTime2'] === null) {
                settings['logTime2'] = '19:00'
            }

            return settings
        }
    },
    mounted() {

    },
    methods: {
        runReport(reportTemplateId = null) {
            let params = {}
            if (reportTemplateId !== null) {
                params['reportTemplateId'] = reportTemplateId
                params['forGroup'] = this.forGroup
            }
            else {
                params['interval'] = this.$data._interval
                params['settings'] = this.$data._settings
            }

            params['end'] = this.endOfInterval
            params['meters'] = this.$data._selectedMeters

            if (this.endOfInterval === Intervals.SEMI_MONTHLY) {
                params['semiMonthHalf'] = this.$data._semiMonthHalf
            }

            // return
            this.$data._runningReport = true
            axios.post(this.company.buildCompanyRoute('group-reports/excursion-report'), params)
                .then(response => {
                    // Clear the error logs, since the report is done.
                    this.$data._reportSuccessfullySent = true
                    this.$data._errorSending = []
                })
                .catch(response => {
                    // Store the logs from errors to show.
                    this.$data._errorSending = response.data
                })
                .finally(() => {
                    // Finish the sending of the report.
                    this.$data._runningReport = false
                })
        },
        resetTemplateRun() {
            this.currentReportTemplateIndex = null
            this.forGroup = false
        },
        setUseStandardReporting(event) {
            this.useStandardReporting = event
        },
        resetSelections() {
            this.$data._selectedMeters = []
        },
    },
    computed: {},
    watch: {
        settings (val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        },
    },
}
</script>

<style scoped>

</style>